import { Version } from "@angular/core";
import { ClassOrString, Parameter, Verylys } from "./verylys";

export enum SOFTWARE_INSTANCE_SERVICE_STATUS {
    STARTING = "starting",
    UP = "up",
    STOPPING = "stopping",
    PAUSED = "paused",
    DOWN = "down"
}


export interface SoftwareInstance extends Verylys {
    _id: string;
    friendly_id: string;
    parameters: {
        service_status: Parameter<SOFTWARE_INSTANCE_SERVICE_STATUS>;
        custom_name: Parameter<string>;
        connected_users: Parameter<number>;
    }

    service_instance: ClassOrString<SoftwareInstance>;
}